import React, {useState,useEffect,useRef} from 'react';
import { useQueryParam, ArrayParam } from 'use-query-params';
import Select from 'react-select'
import { useSelector } from 'react-redux'

const DepartmentFilter = (prop) => {

    const allDepartments = useSelector((state) => state.chatprop.allDepartments)



    const ref = useRef()

    const [isMenuOpen, setIsMenuOpen] = useState(false)
    const [selectedDepartment, setSelectedDepartment] = useState([])
    const [closeFilter, setCloseFilter] = useState(false);
    const [department, setDepartment] = useQueryParam('department', ArrayParam);



    const closeFilterFunc=()=>{
        setDepartment(undefined);
        prop.closeFilter(prop.filterDetail['name']);
        prop.filtering();
    }
    const completeSelect=()=>{

        const temp=[];
        selectedDepartment.map(depKey => (
            temp.push(depKey.value)
        ));
        setDepartment(temp);

        prop.filtering();
    }

    const onMouseOver=()=>{
        setCloseFilter(true);
    }
    const onMouseOut=()=>{
        setCloseFilter(false);
    }


    const closeWrap=()=>{

        if(typeof department==="undefined"){
            setDepartment(undefined);
            prop.closeFilter(prop.filterDetail['name']);
        }
        setIsMenuOpen(false);
    }
    const doneSelect=()=>{
        completeSelect();
        setIsMenuOpen(false);
    }
    const selectDepartment=(selectedOption)=>{
        setSelectedDepartment(selectedOption);




    }
    const  changeMenuOpen=(state)=>{
        prop.changeShowIs(state,prop.filterDetail['name']);
    }
    useEffect(() => {

        if(typeof department!=="undefined"){

            const temp=[];

            if(Object.keys(department).length>0){
                department.map(departmentKey => (
                    Object.keys(allDepartments).length>0 ?
                        allDepartments.map(depKey=>(
                            depKey.id==departmentKey ?
                                temp.push({
                                    "value":depKey.id,
                                    "label":depKey.name
                                })
                                : ""

                        ))
                        :
                        ""
                ));
            }


            setSelectedDepartment(temp);
        }
        if(!prop.showis){

            setIsMenuOpen(true);
            changeMenuOpen(true);
        }
    }, [prop.showis])

    useEffect(() => {

        const checkIfClickedOutside = e => {
            if (isMenuOpen && ref.current && !ref.current.contains(e.target)) {
                setIsMenuOpen(false);
                if(typeof department==="undefined"){
                    setDepartment(undefined);
                    prop.closeFilter(prop.filterDetail['name']);
                }

            }
        }
        document.addEventListener("mousedown", checkIfClickedOutside)
        return () => {
            document.removeEventListener("mousedown", checkIfClickedOutside)
        }
    }, [isMenuOpen])

    return (

        <div
            className="filter-item"
            ref={ref}>
            <button
                onMouseEnter={onMouseOver}
                onMouseLeave={onMouseOut}
                onClick={() => setIsMenuOpen(oldState => !oldState)}
                className=" selected-filter-button">
                {closeFilter === false &&
                <i className={prop.filterDetail['icon']} ></i>
                }

                {closeFilter===true &&
                <i
                    onClick={closeFilterFunc}
                    className="bx bx-x" ></i>
                }

                {Object.keys(selectedDepartment).length>0 &&
                <span>

                    {Object.keys(selectedDepartment).map(sdep=>{
                        return (sdep==1 ? " OR " : "") +(sdep>=2 ? (sdep==2 ?"..." : "") : selectedDepartment[sdep]['label'])

                    })}
                </span>
                }
                {Object.keys(selectedDepartment).length<1 &&
                <span>{prop.filterDetail['name']}</span>
                }

            </button>

            {isMenuOpen === true &&
            <div className="filter-item-wrap">
                <div className="filter-item-content">
                    <div className="filter-item-content-header">
                        <span><i className={prop.filterDetail['icon']}></i></span>
                        <span>{prop.filterDetail['name']}</span>

                    </div>
                    <div className="form">
                        <Select
                            defaultValue={selectedDepartment}
                            options={allDepartments.map(dep=>({
                                value:dep.id,
                                label:dep.name
                            }))}
                            isMulti
                            closeMenuOnSelect={true}
                            placeholder="choose department"
                            onChange={selectDepartment}
                            noOptionsMessage={() => "department not found"}

                        />
                    </div>
                    <div className="form">
                        {Object.keys(selectedDepartment).length<1 &&
                        <button
                            onClick={closeWrap}
                            className="btn btn-primary btn-lg btn-block">Close</button>
                        }
                        {Object.keys(selectedDepartment).length>0 &&
                        <button
                            onClick={doneSelect}
                            className="btn btn-primary btn-lg btn-block"
                        >Done</button>
                        }
                    </div>
                </div>
            </div>
            }
        </div>

    );

};

export default DepartmentFilter;
